import React from 'react';
import 'stream-chat-react/dist/css/v2/index.css';
import './ChatList.scss';

interface ChatListProps {
  channels: any[];
  selectedChannelId: string | null;
  onSelectChannel: (channel: any) => void;
  onMemberClick: (memberId: string) => void;
  isLoading?: boolean;
  searchQuery?: string;
  onSearchQueryChange?: (value: string) => void;
}

const ChatList: React.FC<ChatListProps> = ({
  channels,
  selectedChannelId,
  onSelectChannel,
  isLoading = false,
  searchQuery,
  onSearchQueryChange,
}) => {

  return (
    <div className="chat-list">
      <div className="chat-search-wrapper">
        <div className="chat-search-input-container">
          <svg
            className="chat-search-icon"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="11" cy="11" r="8"></circle>
            <path d="M21 21l-4.35-4.35"></path>
          </svg>
          <input
            type="text"
            className="chat-search-input"
            placeholder="Search chats"
            value={searchQuery ?? ''}
            onChange={(e) => onSearchQueryChange?.(e.target.value)}
          />
        </div>
      </div>
      <div className="chat-list-items">
        {isLoading ? (
          <div className="chat-list-loading">
            <div className="chat-loading-spinner"></div>
            <p className="chat-loading-text">Loading conversations...</p>
          </div>
        ) : channels.length > 0 ? (
          channels.map((channel) => {
            const isSelected = selectedChannelId === channel.id;
            const unreadCount = Number(channel.unreadCount) || 0;

            return (
              <div
                key={channel.id}
                className={`chat-list-item ${isSelected ? 'selected' : ''}`}
                onClick={() => onSelectChannel(channel)}
              >
                <div className="chat-item-avatar">
                  <div className="chat-avatar-placeholder">
                    {(channel.memberName?.[0] || 'M').toUpperCase()}
                  </div>
                </div>
                <div className="chat-item-content">
                  <div className="chat-item-name">
                    {channel.memberName}
                  </div>
                </div>
                {unreadCount > 0 && (
                  <div className="chat-item-unread-badge">
                    {unreadCount > 99 ? '99+' : unreadCount}
                  </div>
                )}
              </div>
            );
          })
        ) : null}
      </div>
    </div>
  );
};

export default ChatList;

